import React from 'react';
import { TouchableWithoutFeedback, View } from 'react-native';

import { ViewPropTypes, TextPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import FoundationTestKeys from '../../../FoundationTestKeys';
import { withTheme, LightThemeColors } from '../../Themes';
import VFText from '../../VFText';

import styles from './DefaultItem.styles';

const DefaultItem = ({
  title,
  titleTextStyle,
  subTitle,
  subTitleTextStyle,
  isActive,
  onPress,
  containerStyle,
  theme,
  ...props
}) => {
  return (
    <TouchableWithoutFeedback
      onPress={onPress}
      {...props}
      testID={FoundationTestKeys.selectionListDefaultItemTO}
    >
      <View
        style={[styles.containerStyle(theme, isActive, subTitle), containerStyle]}
        testID={FoundationTestKeys.selectionListDefaultItemView}
      >
        <VFText
          style={titleTextStyle}
          i18nKey={title}
          testKey={FoundationTestKeys.selectionListDefaultItemTitle}
        />
        {subTitle && (
          <VFText
            style={[styles.subTitle, subTitleTextStyle]}
            i18nKey={subTitle}
            testKey={FoundationTestKeys.selectionListDefaultItemSubTitle}
          />
        )}
      </View>
    </TouchableWithoutFeedback>
  );
};

DefaultItem.defaultProps = {
  isActive: false,
  onPress: () => {},
  theme: LightThemeColors,
};

DefaultItem.propTypes = {
  title: PropTypes.string,
  titleTextStyle: TextPropTypes.style,
  subTitle: PropTypes.string,
  subTitleTextStyle: TextPropTypes.style,
  isActive: PropTypes.bool,
  onPress: PropTypes.func,
  containerStyle: ViewPropTypes.style,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
};

export default withTheme(DefaultItem);
